import {
  loadSetting,
} from "Apis/nutzer-api";
import {
  ASTMODUSEMPTY,
  ROLLEN,
} from "App/constants";

export async function getModus(props, noRedirect = false) {
  const { user, flag_antragstellermodus, history } = props;

  // Ermitteln, welcher Ast-Modus gerade aktiv ist

  /*
   * 1. Wenn flag_antragstellermodus in den props ist, glauben wir diesem
   * 2. Versuchen, Setting per Service laden
   * 3. Wenn es noch nicht vorhanden ist, mit Default "Hilfskraft" schreiben
   * 4. Wert zurückliefern, egal wie er ermittelt wurde
   */

  // Wichtig: Die Props der aufrufenden Komponente (in UNSAFE_componentWillReceiveProps) müssen den "user" enthalten

  if (user && user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER) {
    let modus = flag_antragstellermodus;
    if (!modus) {
      const conf = await loadSetting("AntragstellerModus");
      if (!conf) {
        modus = ASTMODUSEMPTY;
        !noRedirect && history && history.push("/");
      } else if (conf) {
        modus = conf.modus;
      }
      modus !== ASTMODUSEMPTY && props.setFlag("antragstellermodus", modus);
    }
    return modus;
  }
}
